var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MdErrorOutline } from 'react-icons/md';
import { themeLss } from "../../lss";
import styled from "../../styled";
import { Icon } from '../Icon';
import { inputStyles } from '../Input';
import { InputWrapper } from '../TextInput';
import { TextInputIcon } from '../TextInput';
import { Tooltip } from '../Tooltip';
var MIN_TEXTAREA_HEIGHT = 16;
var StyledTextArea = styled.textarea(inputStyles, themeLss({
    p: 'md'
}));
export var TextArea = React.forwardRef(function (_a, ref) {
    var leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, rightButton = _a.rightButton, _b = _a.disabled, disabled = _b === void 0 ? false : _b, isInvalid = _a.isInvalid, error = _a.error, _c = _a.showValidationToolTip, showValidationToolTip = _c === void 0 ? false : _c, _d = _a.isTouched, isTouched = _d === void 0 ? false : _d, value = _a.value, _e = _a.isAutoScaling, isAutoScaling = _e === void 0 ? false : _e, onChange = _a.onChange, props = __rest(_a, ["leftIcon", "rightIcon", "rightButton", "disabled", "isInvalid", "error", "showValidationToolTip", "isTouched", "value", "isAutoScaling", "onChange"]);
    var textAreaRef = (ref
        ? ref
        : React.useRef(null));
    var autoExpandTextAreaHeight = function () {
        if (textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) {
            // Reset height - important to shrink on delete
            textAreaRef.current.style.height = 'inherit';
            // Set height
            textAreaRef.current.style.height = Math.max(textAreaRef.current.scrollHeight, MIN_TEXTAREA_HEIGHT) + "px";
        }
    };
    // Updates textarea height on first render
    React.useLayoutEffect(function () {
        if (isAutoScaling)
            autoExpandTextAreaHeight();
    }, [value]);
    var onIconClick = function () { var _a; return textAreaRef && ((_a = textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus()); };
    var validationToolTip = showValidationToolTip && error ? (React.createElement(Tooltip, { title: error, enforceRefWrapper: true, placement: "auto", colorScheme: "error" },
        React.createElement(Icon, { as: MdErrorOutline, size: 18, lss: { color: 'danger' } }))) : null;
    return (React.createElement(InputWrapper, { disabled: disabled, title: error ? error : undefined, isInvalid: isInvalid, isTouched: isTouched },
        leftIcon && (React.createElement(TextInputIcon, { isIconBgTransparent: true, position: "left", lss: { alignSelf: 'flex-start' }, onClick: onIconClick }, leftIcon)),
        React.createElement(StyledTextArea, __assign({ lss: { resize: isAutoScaling ? 'none' : 'vertical' }, disabled: disabled, value: value, onChange: function (value) {
                if (isAutoScaling)
                    autoExpandTextAreaHeight();
                onChange && onChange(value);
            } }, props, { ref: textAreaRef })),
        rightIcon && (React.createElement(TextInputIcon, { isIconBgTransparent: true, position: "right", lss: { alignSelf: 'flex-start' }, onClick: onIconClick }, rightIcon)),
        validationToolTip && (React.createElement(TextInputIcon, { isIconBgTransparent: true, position: "right", lss: { alignSelf: 'flex-start' }, onClick: onIconClick }, validationToolTip)),
        rightButton));
});
//# sourceMappingURL=TextArea.js.map